import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "@/components/ui/select";

// Unified, blueprint-styled licence-area selector used across every SYMIN module.
export function AreaSelect({ areas = [], value, onChange, accent = "#C20511", testid = "area-select", className = "" }) {
  return (
    <Select value={value || ""} onValueChange={onChange}>
      <SelectTrigger
        data-testid={testid}
        style={{ "--sel-accent": accent }}
        className={`h-8 w-[150px] sm:w-[210px] bg-[#0B1420] border-[#1B2A42] text-xs font-medium text-slate-200 rounded-md focus:ring-1 focus:ring-[var(--sel-accent)] focus:border-[var(--sel-accent)] hover:border-[var(--sel-accent)]/60 transition-colors truncate ${className}`}>
        <SelectValue placeholder="Select area" />
      </SelectTrigger>
      <SelectContent className="bg-[#0E1A2C] border-[#1B2A42] text-slate-200 z-[1100]">
        {areas.map((a) => (
          <SelectItem key={a.area_id} value={a.area_id}
            className="text-xs font-mono focus:bg-[#162540] focus:text-slate-100 data-[state=checked]:text-[var(--sel-accent)]"
            style={{ "--sel-accent": accent }}
            disabled={a.status && a.status !== "complete"}>
            <span className="flex items-center gap-2">
              <span className="h-1.5 w-1.5 rounded-full shrink-0" style={{ background: a.status === "complete" ? accent : "#52637D" }} />
              <span className="truncate max-w-[170px]">{a.name}{a.status && a.status !== "complete" ? " · not processed" : ""}</span>
            </span>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
